/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Col, Row, FormGroup, Label, Button } from 'reactstrap'

import PasswordWidget from '../widgets/PasswordWidget.js'

import {AppContext} from '../AppContext';

// TODO: the password inputs and zxcvbn loading is done in Signup, ResetPassword and here (ChangePassword) 
// (anywhere else? ChangePassword.js.old)... we should abstract, if possible, the password input into a single sub-component
// UPDATE: THIS FILE *is* an abstraction used in ManageProfile, but it would have to use some props to change its behavior
// when being used by ResetPassword or Signup (includes what API to call, whether or not to require the old password, 
// success/error messages, whether or not to redirect (and having a modal popup vs. notification widget, etc))

class ChangePassword extends React.Component
{
  currentPassword = null;
  newPassword = null;
  confirmation = null;

  constructor(props)
  {
    super();

    this.state =
    {
      currentPassword: '',
      currentPasswordValid: undefined,
      currentPasswordType: 'password',
      newPassword: '',
      newPasswordValid: undefined,
      newPasswordScore: null,
      confirmation: '',
      confirmationValid: undefined,
      confirmationFB: null,
      currentPasswordFB: null,
      newPasswordFB: null,
      buttonDisabled: true
    }

    this.changePassword = this.changePassword.bind(this);

    window.loadZxcvbn();    
  }

  async changePassword(event)
  {
    this.setState({buttonDisabled: true});

    let bodyData = {};
    bodyData.currentPassword =  this.state.currentPassword;
    bodyData.newPassword = this.state.newPassword;

    let result = await this.context.dbTwig.callRestAPI('icam', 'changePassword', bodyData);
    if ('success' !== result.status)
    {
      this.setState({buttonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error changing password');
    }

    this.context.postNotification('info', "Your password has been changed. Please use your new password to log in from now on.");
    if (undefined !== this.props.setSessionStatus) this.props.setSessionStatus(result.jsonData.sessionStatus);
  }

  render()
  {
    if (undefined !== this.props.activeTab && !this.props.activeTab) return false;

    let text1 = null, text2 = null;
    if ('change password' === this.context.userSession.sessionInfo.sessionStatus)
      text1 = (
        <div>
          <Row style={{paddingTop: "10px", paddingBottom: "10px"}}>
            <Col style={{size: 2, offset: 2}}><b>You must change your password before you can continue.</b></Col>
          </Row>
        </div>
      );

    return(
      <div>
        {text1}
        {text2}
        <FormGroup row>
          <Label for="currentPassword" sm="2">Current Password</Label>
          <Col sm="3" >
            <PasswordWidget onChange={this.setPasswordVar.bind(this, 'currentPassword')} value={this.state.currentPassword}
              passwordValid={this.state.currentPasswordValid} passwordFB={this.state.currentPasswordFB} 
              placeholder='Enter your current password' id='currentPassword' focus={true}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="newPassword" sm="2">New Password</Label>
          <Col sm="3" >
            <PasswordWidget onChange={this.setPasswordVar.bind(this, 'newPassword')} value={this.state.newPassword}
              passwordValid={this.state.newPasswordValid} passwordFB={this.state.newPasswordFB} 
              placeholder='Enter your new password' zxcvbn={this.state.newPasswordScore} id='newPassword'
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="confirmation" sm="2">Confirmation Password</Label>
          <Col sm="3" >
            <PasswordWidget onChange={this.setPasswordVar.bind(this, 'confirmation')} value={this.state.confirmation}
              passwordValid={this.state.confirmationValid} passwordFB={this.state.confirmationFB} 
              placeholder='Enter your new password again' id='confirmation'
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={{ size: 3, offset: 2 }}>
            <Button onClick={this.changePassword} disabled={this.state.buttonDisabled} color="primary">Change Password</Button>
          </Col>
        </FormGroup>
      </div>
    );
  }

  setPasswordVar(field, value)
  {
    let currentPasswordValid = this.state.currentPasswordValid;
    let newPasswordValid = this.state.newPasswordValid;
    let confirmationValid = this.state.confirmationValid;

    let currentPassword = this.state.currentPassword;
    let currentPasswordFB = null;
    let newPassword = this.state.newPassword;
    let newPasswordFB = null;
    let confirmation = this.state.confirmation;
    let confirmationFB = null;

    let newPasswordScore = this.state.newPasswordScore;

    switch (field)
    {
      case 'currentPassword':
        currentPassword = value;
        if ('' === currentPassword)
        {
          currentPasswordValid = false;
          currentPasswordFB = 'You must enter your current password in order to continue.';
        }
        else
        {
          currentPasswordValid = true;
          currentPasswordFB = null;
        }
        break;

      case 'newPassword':
        newPassword = value;
        let newPasswordZxcvbn = window.getPasswordScore(newPassword);
        newPasswordScore = newPasswordZxcvbn.score;
        if ('' === newPassword)
        {
          newPasswordValid = false;
          newPasswordFB = 'You must enter a strong new password to continue.';
        }
        else if (newPasswordZxcvbn.score < this.context.websiteProfile.passwordStrength)
        {
          newPasswordFB = newPasswordZxcvbn.feedback.warning
          newPasswordValid = false;
        }
        else
        {
          newPasswordValid = true;
          newPasswordFB = null;
        }

        break;

      case 'confirmation':
        confirmation = value
        if ('' === confirmation)
        {
          confirmationValid = false;
          confirmationFB = 'You must confirm your new password by typing it in again.';
        }
        else
        {
          confirmationValid = true;
          confirmationFB = null;
        }
        break;

      default:
        break;
    }

    if (currentPasswordValid && newPasswordValid && currentPassword === newPassword)
    {
      newPasswordValid = false;
      newPasswordFB = 'You can not re-use your current password.';
    }

    if (currentPasswordValid && newPasswordValid && confirmationValid && newPassword !== confirmation)
    {
      confirmationFB = 'Your passwords do not match!';
      confirmationValid = false;
    }

    let buttonDisabled = (currentPasswordValid && newPasswordValid && confirmationValid ? false : true);

    this.setState(
    {
      currentPassword: currentPassword,
      currentPasswordValid: currentPasswordValid,
      currentPasswordFB: currentPasswordFB,
      newPassword: newPassword,
      newPasswordValid: newPasswordValid,
      newPasswordFB: newPasswordFB,
      newPasswordScore: newPasswordScore,
      confirmation: confirmation,
      confirmationValid: confirmationValid,
      confirmationFB: confirmationFB,
      buttonDisabled: buttonDisabled
    });
  }
}

ChangePassword.contextType = AppContext;

export default ChangePassword